module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.f775f9cc.svg";